import { render, staticRenderFns } from "./item-price-update.vue?vue&type=template&id=617924fc&"
import script from "./item-price-update.vue?vue&type=script&lang=js&"
export * from "./item-price-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports